package org.multipaz.device

data class DeviceAttestationResult(
    /**
     * Identifier for the opaque private key generated by [DeviceCheck.generateAttestation]
     * method for use with [DeviceCheck.generateAssertion].
     */
    val deviceAttestationId: String,

    /**
     * Data that proves the platform integrity and can be used to validate a [DeviceAssertion].
     */
    val deviceAttestation: DeviceAttestation
)